import React from 'react';
const brands = [{
  name: 'Apple',
  logo: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg'
}, {
  name: 'Samsung',
  logo: 'https://images.unsplash.com/photo-1587817229766-65fa3f8fda04?w=150'
}, {
  name: 'Xiaomi',
  logo: 'https://images.unsplash.com/photo-1598327105666-5b89351aff97?w=150'
}, {
  name: 'Anker',
  logo: 'https://images.unsplash.com/photo-1583863788434-e58a36330cf0?w=150'
}, {
  name: 'JBL',
  logo: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=150'
}, {
  name: 'Logitech',
  logo: 'https://images.unsplash.com/photo-1527814050087-3793815479db?w=150'
}];
export function BrandsSection() {
  return <section className="py-12 bg-white" aria-labelledby="brands-heading" data-id="element-90" data-mp="gkyqaxrmtcxo">
      <div className="max-w-7xl mx-auto px-4" data-id="element-91" data-mp="lf2xni4t7mza">
        <h2 id="brands-heading" className="text-center text-lg font-medium text-gray-500 mb-8" data-id="element-92" data-mp="3l19kqdieo7ab">
          Trusted Brands We Carry
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16" data-id="element-93" data-mp="3p11z56uhd7nl">
          {brands.map(brand => <div key={brand.name} className="grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300" data-id="element-94" data-mp="145v7sjv88h5v">
              <div className="w-24 h-12 flex items-center justify-center" data-id="element-95" data-mp="ugljlf3i7in1">
                <span className="text-2xl font-bold text-gray-400 hover:text-gray-900 transition-colors" data-id="element-96" data-mp="ueqtlmddl0c3">
                  {brand.name}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}